import { useEffect, useState } from "react";
import {
  getService,
  PostService,
  PostServiceWithFile,
} from "../GenericServices/genericService";
import { resources_EN } from "../GenericServices/componentUtils";
import Swal from "sweetalert2";

const UpdateProductModal = ({
  showEditModal,
  setShowEditModal,
  editProductData,
  getProductAPI,
}) => {
  const [formData, setFormData] = useState({
    name: "",
    price: "",
    category: "",
    image: null,
    description: "",
  });

  const [category, setCategory] = useState([]);

  useEffect(() => {
    getCategoryAPI();
  }, []);

  useEffect(() => {
    if (editProductData) {
      setFormData({
        ...editProductData,
        prod_img: editProductData.prod_img
          ? `../myNewAPI/${editProductData.prod_img}`
          : null,
      });
    }
  }, [editProductData]);

  const handleFileChange = (e) => {
    setFormData({
      ...formData,
      prod_img: e.target.files[0],
    });
  };

  const handleUpdateAPI = () => {
    // Implement API call to update product
    const url = "myNewAPI/update_product.php";
    let data = {
      ...formData,
      prod_id: formData.prod_id,
    };
    console.log("Update Data:", data);
    PostServiceWithFile(url, data, modal);
  };

  const getCategoryAPI = () => {
    const url = "myNewAPI/get_category.php";
    getService(url, {}, setCategoryData);
  };

  const setCategoryData = (response) => {
    setCategory(response.category);
  };

  /* Error or Success Modal */
  const modal = (icon, title, message, response = "") => {
    Swal.fire({
      title: title,
      icon: icon,
      text: message,
    }).then((resp) => {
      if (resp.isConfirmed && icon === resources_EN.success) {
        setShowEditModal(false);
        setFormData({});
        getProductAPI();
      }
    });
  };

  console.log("Edit Product Data in Modal:", formData);
  return (
    showEditModal && (
      <div className="fixed inset-0 bg-black bg-opacity-50 z-[100] flex items-center justify-center p-4">
        <div className="bg-white rounded-lg p-6 w-full max-w-md">
          <h2 className="text-xl font-bold mb-4">Edit Product</h2>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleUpdateAPI();
            }}
          >
            <input
              type="text"
              placeholder="Name"
              value={formData.prod_name}
              onChange={(e) =>
                setFormData({ ...formData, prod_name: e.target.value })
              }
              className="w-full mb-4 p-2 border"
              required
            />
            <input
              type="number"
              placeholder="Price"
              value={formData.prod_price}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  prod_price: parseFloat(e.target.value),
                })
              }
              className="w-full mb-4 p-2 border"
              required
            />
            <input
              type="number"
              placeholder="Quantity"
              value={formData.prod_quantity}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  prod_quantity: parseInt(e.target.value),
                })
              }
              className="w-full mb-4 p-2 border"
              required
            />
            <select
              placeholder="Category"
              value={formData.cat_title}
              onChange={(e) => {
                console.log("Event:", e.target.value);
                setFormData({ ...formData, cat_title: e.target.value });
              }}
              className="w-full mb-4 p-2 border"
              required
            >
              <option value="">Select Category</option>
              {category.map((cat, index) => (
                <option key={index} value={cat.cat_id}>
                  {" "}
                  {cat.cat_title}{" "}
                </option>
              ))}
            </select>
            <div className="mb-4">
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Product Image
              </label>
              <input
                type="file"
                accept="image/*"
                onChange={handleFileChange}
                className="w-full p-2 border"
              />
              {formData.prod_img && (
                <img
                  src={formData.prod_img}
                  alt="Preview"
                  className="mt-2 w-24 h-24 object-cover"
                />
              )}
            </div>
            <textarea
              placeholder="Description"
              value={formData.prod_descrp}
              onChange={(e) =>
                setFormData({ ...formData, prod_descrp: e.target.value })
              }
              className="w-full mb-4 p-2 border"
              required
            />
            <div className="flex justify-end">
              <button
                type="button"
                onClick={() => setShowEditModal(false)}
                className="mr-4 px-4 py-2 text-gray-600"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-4 py-2 bg-blue-600 text-white"
              >
                Update
              </button>
            </div>
          </form>
        </div>
      </div>
    )
  );
};

export default UpdateProductModal;
